import { render } from "./SendTxButton.vue?vue&type=template&id=03d6b6d8"
import script from "./SendTxButton.vue?vue&type=script&lang=js"
export * from "./SendTxButton.vue?vue&type=script&lang=js"

import exportComponent from "/Users/quentinpuechguiral/Documents/inProgress/patentidea.web3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__